import './packages.scss'

function Packages() {
    return(
        <div className='packages'>
            <h2 className='packages__title'>
                Ready to get started with
                Lemon Wares?
            </h2>
            <div className='packages__text'>Choose the package that suits you</div>
            <div className='packages__switch'>
                Monthly
                <label className='switch'>
                    <input type='checkbox'/>
                    <span className='slider round'></span>
                 </label>
                Yearly
            </div>
            <div className='packages__types'>
                <ul className='menu'>
                    <li className='menu__item'>
                        <a href='/' className='link link_active'>Basic</a>
                    </li>
                    <li className='menu__item'>
                        <a href='/' className='link'>Premium</a>
                    </li>
                </ul>
            </div>
            <div className='packages__list'>
                <div className='package'>
                    <div className='package__title'>Starter</div>
                    <div className='package__text'>
                        with all your customers via all conversation channels in one central dashboard.
                    </div>
                    <div className='package__price'>
                        <div className='money'>$2.80</div>
                        <div className='period'>Per month</div>
                    </div>
                    <button>Choose this Plan</button>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        2GB SSD
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        10GB Bandwidth
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        15 Email Accounts
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        Unlimited Database
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        4 Subdomains
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        1 Parked Domain
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        2 Websites
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        Free SSL
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        Softaculous
                    </div>
                </div>
                <div className='package'>
                    <div className='package__title'>Standard</div>
                    <div className='package__text'>
                        with all your customers via all conversation channels in one central dashboard.
                    </div>
                    <div className='package__price'>
                        <div className='money'>$4.20</div>
                        <div className='period'>Per month</div>
                    </div>
                    <button>Choose this Plan</button>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        2GB SSD
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        10GB Bandwidth
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        15 Email Accounts
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        Unlimited Database
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        4 Subdomains
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        1 Parked Domain
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        2 Websites
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        Free SSL
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        Softaculous
                    </div>
                </div>
                <div className='package'>
                    <div className='package__title'>Suprem</div>
                    <div className='package__text'>
                        with all your customers via all conversation channels in one central dashboard.
                    </div>
                    <div className='package__price'>
                        <div className='money'>$7.00</div>
                        <div className='period'>Per month</div>
                    </div>
                    <button>Choose this Plan</button>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        2GB SSD
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        10GB Bandwidth
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        15 Email Accounts
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        Unlimited Database
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        4 Subdomains
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        1 Parked Domain
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        2 Websites
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        Free SSL
                    </div>
                    <div className='package__feature'>
                        <span className='checkmark'>✓</span>
                        Softaculous
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Packages
